var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"member-item"},[_c('div',{staticClass:"member-image-wrapper",class:{
      'this-is-me': _vm.authId === _vm.participantId,
      medium: _vm.size === 'medium'
    }},[(_vm.imageUrl)?_c('div',{staticClass:"image-background",style:({
        'background-image': ("url(" + _vm.imageUrl + ")")
      })}):_c('initials-avatar',{attrs:{"first-name":_vm.firstName,"last-name":_vm.lastName,"size":10}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }